import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { NgxSpinnerService } from "ngx-spinner";
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-valores-minimos',
  templateUrl: './valores-minimos.component.html',
  styleUrls: ['./valores-minimos.component.scss', '../../styles/estilo.padrao.scss']
})
export class ValoresMinimosComponent implements OnInit {
  uid;
  valoresForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
  ) {
    this.uid = localStorage.getItem('uid');
    this.spinner.show('valores-minimos');
  }

  ngOnInit(): void {

    //Algoritmo de atualização de latitude e longitude em demanda
    //Remover
    // this.usuarioService.getClientes().pipe(take(1)).subscribe(snap => {
    //   if (snap) {
    //     console.log(snap.length);

    //     var dados;

    //     let clientes = [];
    //     snap.forEach((item, index) => {
    //       dados = item.payload.val();

    //       if (!dados.Latitude) {
    //         clientes.push({ IDCliente: item.key, Endereco: dados.Logradouro + ', ' + dados.Bairro + ', ' + dados.Cidade + ',' + dados.UF, Latitude: false, Longitude: false });
    //       }
    //     });

    //     Promise.all(clientes.map(async (value) => {

    //       if (value) {
    //         const aux: any = await this.usuarioService.getLatLng(value.Endereco);

    //         if (JSON.parse(aux._body).results[0]) {
    //           const dadosLatLng = JSON.parse(aux._body).results[0].geometry.location;
    //           value.Latitude = dadosLatLng.lat;
    //           value.Longitude = dadosLatLng.lng
    //         }
    //       }

    //     })).then(resp => {

    //       console.log('FINALY')
    //       console.log(clientes)

    //       Promise.all(clientes.map(async (value) => {

    //         if (value) {
    //           if (value.Latitude && value.Longitude) {
    //             const aux: any = await this.usuarioService.updateLatitudeLongitude(value.IDCliente, value.Latitude, value.Longitude);
    //           }
    //         }

    //       })).then(resp => {

    //         console.log('')
    //         console.log(clientes)
    //       });
    //     });

    //   }
    // })
    //Remover

    this.valoresForm = this.formBuilder.group({
      minimoPedido: [0, [Validators.required, Validators.min(0)]],
      minimoBoleto: [100, [Validators.required, Validators.min(0)]],
      minimoBoletoQuinzeDias: [200, [Validators.required, Validators.min(0)]],
      minimoDivisaoPagamentoDoisBoletos: [300, [Validators.required, Validators.min(0)]],
      minimoDescontoCompraDinheiro: [10, [Validators.required, Validators.min(0)]],
      minimoCheque: [0, [Validators.required, Validators.min(0)]],
      porcentagemDescontoComprasDinheiro: [0, [Validators.required, Validators.min(0)]],
      bHabilitarDescontoDinheiro: [false, [Validators.required, Validators.min(0)]],
      bHabilitarPix: [false, [Validators.required, Validators.min(0)]],
    });

    this.usuarioService.getValoresMinimos().pipe(take(1)).subscribe(snap => {
      const dados: any = snap.payload.val();
      if (dados) {
        this.valoresForm.get('minimoPedido').patchValue(dados.Pedido);
        this.valoresForm.get('minimoBoleto').patchValue(dados.Boleto);
        this.valoresForm.get('minimoCheque').patchValue(dados.Cheque);
        this.valoresForm.get('minimoBoletoQuinzeDias').patchValue(dados.BoletoQuinzeDias);
        this.valoresForm.get('minimoDivisaoPagamentoDoisBoletos').patchValue(dados.BoletoDuasParcelas);
        this.valoresForm.get('minimoDescontoCompraDinheiro').patchValue(dados.MinimoDescontoCompraDinheiro ?? 0);
        this.valoresForm.get('porcentagemDescontoComprasDinheiro').patchValue(dados.PorcentagemDescontoComprasDinheiro ?? 0);
        this.valoresForm.get('bHabilitarDescontoDinheiro').patchValue(dados.HabilitarDescontoCompraDinheiro);
        this.valoresForm.get('bHabilitarPix').patchValue(dados.HabilitarPix);
      }

      setTimeout(() => this.spinner.hide('valores-minimos'), 300);
    });
  }

  async salvar() {

    this.spinner.show('default');

    if (this.valoresForm.valid) {

      try {
        const resp = await this.usuarioService.updateValoresMinimos(this.uid,
          {
            Boleto: this.f.minimoBoleto.value,
            Pedido: this.f.minimoPedido.value,
            BoletoQuinzeDias: this.f.minimoBoletoQuinzeDias.value,
            BoletoDuasParcelas: this.f.minimoDivisaoPagamentoDoisBoletos.value,
            Cheque: this.f.minimoCheque.value,
            PorcentagemDescontoComprasDinheiro: this.f.porcentagemDescontoComprasDinheiro.value > 100 ? this.f.porcentagemDescontoComprasDinheiro.value / 100 : this.f.porcentagemDescontoComprasDinheiro.value,
            HabilitarDescontoCompraDinheiro: this.f.bHabilitarDescontoDinheiro.value,
            MinimoDescontoCompraDinheiro: this.f.minimoDescontoCompraDinheiro.value,
            HabilitarPix: this.f.bHabilitarPix.value
          });
        setTimeout(() => {
          this.spinner.hide('default');
          if (resp !== null) {

            this.usuarioService.setLog("Alteração de valores mínimos: Boleto" + this.f.minimoBoleto.value + ' Pedido: ' + this.f.minimoPedido.value + ' BoletoQuinze: ' + this.f.minimoBoletoQuinzeDias.value + ' Dois boletos: ' + this.f.minimoDivisaoPagamentoDoisBoletos.value + ' Cheque: ' + this.f.minimoCheque.value, false, this.uid);

            this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
              this.router.navigate(["/pages/valores-minimos"], { queryParams: { IDGrupo: resp } }));
          } else {
            this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
              this.router.navigate(["/pages/valores-minimos"]));
          }
        }, 1500);
      } catch (e) {
        console.log(e)
        this.spinner.hide('default');

        this.usuarioService.setLog("Erro na alteração de valores mínimos: Boleto" + this.f.minimoBoleto.value + ' Pedido: ' + this.f.minimoPedido.value + ' BoletoQuinze: ' + this.f.minimoBoletoQuinzeDias.value + ' Dois boletos: ' + this.f.minimoDivisaoPagamentoDoisBoletos.value + ' Cheque: ' + this.f.minimoCheque.value + ' Erro: ' + e, null, this.uid);

        this.toastr.error('Erro ao atulizar valores!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/pages/valores-minimos"]));
      }

    } else {
      this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      this.valoresForm.markAllAsTouched();
      setTimeout(() => this.spinner.hide('default'), 500);
    }

  }

  // convenience getter for easy access to form fields
  get f() { return this.valoresForm.controls; }

}
